var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHearth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.682 20.278C11.308 20.4129 10.692 20.4129 10.318 20.278C7.128 19.1657 0 14.5252 0 6.66005C0 3.18814 2.739 0.37915 6.116 0.37915C8.118 0.37915 9.889 1.36791 11 2.896C12.111 1.36791 13.893 0.37915 15.884 0.37915C19.261 0.37915 22 3.18814 22 6.66005C22 14.5252 14.872 19.1657 11.682 20.278Z",
    fill: "#9966CC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHearth);
export default __webpack_public_path__ + "static/media/hearth.ef3c3069d84cb705e5beab0d587ac612.svg";
export { ForwardRef as ReactComponent };